import * as Yup from "yup";

const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s'-]+$/;

const ForVouResolvers: {[key: string]: Yup.AnySchema} = {
    name: Yup.string().required().matches(nameRegex, "Pole nie może zawierać znaków specjalnych").min(3, "Wpisz conajmniej 3 znaki"),
    phone: Yup.object()
        .shape({
            code: Yup.number().required(),
            number: Yup.string().required()
        })
        .required(),
    email: Yup.string().email().required()
};

export const useForYouFormResolvers = (names: string[]) => {
    const resolvers = names.reduce((acc, name) => {
        const resolver = ForVouResolvers[name];
        if (resolver) {
            return {...acc, [name]: resolver};
        }
        return acc;
    }, {});

    return Yup.object(resolvers);
};
import * as Yup from "yup";

const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s'-]+$/;

const ForVouResolvers: {[key: string]: Yup.AnySchema} = {
    name: Yup.string().required().matches(nameRegex, "Pole nie może zawierać znaków specjalnych").min(3, "Wpisz conajmniej 3 znaki"),
    phone: Yup.object()
        .shape({
            code: Yup.number().required(),
            number: Yup.string().required()
        })
        .required(),
    email: Yup.string().email().required()
};

export const useForYouFormResolvers = (names: string[]) => {
    const resolvers = names.reduce((acc, name) => {
        const resolver = ForVouResolvers[name];
        if (resolver) {
            return {...acc, [name]: resolver};
        }
        return acc;
    }, {});

    return Yup.object(resolvers);
};
